// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3w5mR","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2Xwm9","obliqueLine":"membershipbadge_obliqueLine__2JlqN"};